import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import GoogleTagManager from '../components/analytics';
import ScrollToTop from '../components/scrolltotop';

const Main = (props) => (
  <HelmetProvider>
    <GoogleTagManager />
    <ScrollToTop />
    <Helmet titleTemplate="%s | Unvexed" defaultTitle="Unvexed" defer={false}>
      {props.title && <title>{props.title}</title>}
      <meta name="description" content={props.description} />
      <meta name='keyword' content='unvexed,digitalmarking,ai,agency,digitalai,ai-marketing,advanced marketing' />    
    </Helmet>
    <div id="wrapper">
      <div id="main">
        {props.children}
      </div>
    </div>
  </HelmetProvider>
);


Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullPage: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

Main.defaultProps = {
  children: null,
  fullPage: false,
  title: null,
  description: "Unvexed | Advanced Digital Marketing Agency",
};

export default Main;
